import { autoinject, BindingEngine, useView } from "aurelia-framework";
import { BaseRuleParameters } from "../../customers/steps/rule-parameters/base-rule-parameters";
import { BusinessUnitRuleConfigParameterModel, BusinessUnitModel } from "../../../../../models/customers/customer.models";
import { LookupClientService } from "../../../../../services/lookups/lookup-client.service";
import { EventAggregator } from "aurelia-event-aggregator";
import { CustomerService } from "../../../../../services/modules/customer-client.service";
import { DialogClientService } from "@rightship-tech/common-ui/services/basic/dialog-client.service";
import { I18N } from "aurelia-i18n";

@autoinject
@useView('views/pages/modules/business-unit/tabs/business-unit-rule-config.html')
export class BusinessUnitRuleConfig extends BaseRuleParameters<BusinessUnitRuleConfigParameterModel> {

    model: BusinessUnitModel;

    constructor(lookupService:LookupClientService, eventAggregator: EventAggregator, private customerService:CustomerService,
        dialogClientServices:DialogClientService, i18n:I18N, bindingEngine: BindingEngine){
        super(lookupService, eventAggregator, dialogClientServices, i18n, bindingEngine);
    }

    async activate(model: { businessUnit: BusinessUnitModel, isReadOnly: boolean })
    {
        this.model = model.businessUnit;
        const response = await this.customerService.getBusinessUnitRuleParameters(this.model.businessUnitId);
        await super.activate(model, response.parameters, "businessUnitRuleConfigParameterId");
    }

    getODataUrl(): string {
        return "BusinessUnitRuleConfigParameters";
    }
}